import { JSX } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { loginLink } from '../../../library/constants';
import { AcceptInvitationCard } from './AcceptInvitationCard';

/**
 * The route shell for an invitation link.
 *
 * Holds the router hooks and nothing else, so the card below can be rendered on its own
 * in a test -- the shared test providers supply no router.
 */
export const Activate = (): JSX.Element => {
    const { key } = useParams();
    const navigate = useNavigate();

    return (
        <AcceptInvitationCard
            activationCode={key}
            onGoToLogin={() => navigate(loginLink)}
        />
    );
};
